<template>
  <div id="app">
    <HeaderComponent @logout="logout"></HeaderComponent>    
    <ServicesComponent ref="services"></ServicesComponent>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from "./components/Header";
import FooterComponent from "./components/Footer";
import ServicesComponent from "./components/Services";
import store from './store';

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
    ServicesComponent
  },
  mounted: function() {
    store.dispatch("retrieveUserDetails"); 
  },
  methods: {
    logout: function() {
      this.$refs.services.logout();
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}
</style>
